﻿import { FC } from "react";
import { Td, Tr } from "@chakra-ui/react";
import { Shimmer } from "../Shimmer";

export const TrLoading: FC<{ colSpan: number }> = ({ colSpan }) => (
    <>
        <Tr>
            <Td colSpan={colSpan}>
                <Shimmer />
            </Td>
        </Tr>
        <Tr>
            <Td colSpan={colSpan}>
                <Shimmer />
            </Td>
        </Tr>
        <Tr>
            <Td colSpan={colSpan}>
                <Shimmer />
            </Td>
        </Tr>
    </>
);
